module.exports = __webpack_public_path__ + "img/19.ed70c502.png";